import { useRouter } from '@backpackjs/storefront';
import { useEffect } from 'react';

/*
  sets the CSS variable root { --viewport-height: 123px } on mount and updates on screen resize.
  This allows us to do i.e sx={{ minHeight: var(--viewport-height) }} to get full height instead
  of using sx= {{ minHeight: 100vh }} which is NOT supported on Safari
*/
export const useSetViewportHeightCssVar = () => {
  const { isPreview } = useRouter();

  useEffect(() => {
    const setViewportHeight = () => {
      const doc = document.documentElement;

      // when in preview we make viewport height - the height of the customizer toolbar
      const viewportHeight = isPreview
        ? `calc(${window.innerHeight}px - var(--backpack-toolbar-height))`
        : `${window.innerHeight}px`;

      doc.style.setProperty('--viewport-height', viewportHeight);
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', setViewportHeight);
      setViewportHeight();
    }

    return () => {
      window.removeEventListener('resize', setViewportHeight);
    };
  }, []);
};
